module.exports = __webpack_public_path__ + "static/media/button-ViewStudents.c7f9a1b8.png";